import { render } from "./legoPaginationExtend.vue?vue&type=template&id=43e5268c&scoped=true"
import script from "./legoPaginationExtend.vue?vue&type=script&lang=js"
export * from "./legoPaginationExtend.vue?vue&type=script&lang=js"

import "./legoPaginationExtend.vue?vue&type=style&index=0&id=43e5268c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e5268c"],['__file',"src/components/lego/extend/legoPaginationExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43e5268c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43e5268c', __exports__)) {
    api.reload('43e5268c', __exports__)
  }
  
  module.hot.accept("./legoPaginationExtend.vue?vue&type=template&id=43e5268c&scoped=true", () => {
    api.rerender('43e5268c', render)
  })

}


export default __exports__